import reducer, { actions } from './slice'
import * as selectors from './selectors'
import * as statelessActions from './actions'

export { actions, selectors, statelessActions }

export default reducer
